// ActiveUsersTile.js — distinct users that placed a call in the window.
// uid is derived from the parent doc ID of each call_history entry.

import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useActiveUserCount } from '../../../hooks/useAdminMetrics';

const ActiveUsersTile = ({ days = 7 }) => {
  const { count, loading, error } = useActiveUserCount(days);

  if (error) {
    return (
      <Card><CardContent>
        <Typography color="error">Active users unavailable: {error.message}</Typography>
      </CardContent></Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>Active Users ({days}d)</Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography variant="h3">{loading ? '…' : count.toLocaleString()}</Typography>
          <Typography variant="caption" color="text.secondary">distinct uids</Typography>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          Number of distinct users who placed at least one phone call in the last {days} days.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ActiveUsersTile;
